export default __webpack_public_path__ + "static/media/roadmap4.4ff16020.svg";